import * as Yup from 'yup'

const validationSchema = Yup.object({
  name: Yup.string().required('Organization Name is required'),
  role: Yup.string().required('Qualification is required'),
  startDate: Yup.date().required('Start Date is required'),
  endDate: Yup.date().notRequired(),
  isCurrent: Yup.boolean(),
})

export default {
  validationSchema,
}
